var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFollowMePressed = function SvgFollowMePressed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 258.75 258.75",
    xmlSpace: "preserve"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FD0403"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 129.375,
    cy: 60,
    r: 60
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.375 150c-60.061 0-108.75 48.689-108.75 108.75h217.5c0-60.061-48.689-108.75-108.75-108.75z"
  }))));
};
export default SvgFollowMePressed;